// extracted by mini-css-extract-plugin
export default {"container":"contact-form_container__EiuUo","title":"contact-form_title__RHwsL","input":"contact-form_input__C+qJp","btnSubmit":"contact-form_btnSubmit__VHAD6"};